import { useState, useRef } from "react";
import { Link } from "react-router-dom";
import HCaptcha from "@hcaptcha/react-hcaptcha";
import { TextInput, Button, Loading, Utils } from "../../Components/Components";

import "./Login.scss";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [token, setToken] = useState(null);
  const captchaRef = useRef(null);
  const form = useRef();

  const onLoad = () => {
    // this reaches out to the hCaptcha JS API and runs the
    // execute function on it. you can use other functions as
    // documented here:
    // https://docs.hcaptcha.com/configuration#jsapi
    captchaRef.current.execute();
  };

  const handleLoginButton = async () => {
    if (username.length === 0) {
      setError("Please provide the Username");
    } else if (password.length === 0) {
      setError("Please provide the Password");
    } else if (!token && process.env.REACT_APP_SKIP_CAPTCHA !== "true") {
      // Em dev local (REACT_APP_SKIP_CAPTCHA=true) o captcha é dispensado.
      // Em hml/prod a variável não existe, então o captcha continua obrigatório.
      Utils.Alert({ title: "Error", text: "Captcha verification failed. Please try again." });
    } else {
      setLoading(true);
      setError("");
      let validation = await Utils.ValidateUser(username, password, token);

      if (validation.error) {
        let error = {};
        switch (validation.error) {
          case 401:
            error = {
              title: "Login Failed",
              text: "Invalid username/password, please check your credencials and try again",
            };
            break;
          case 403:
            error = {
              title: "Your user is outdated",
              text: 'Please access our "Forgot Password" Flow to request a new password and continue using the platform!',
            };
            break;
          case 500:
            error = {
              title: "Server Busy",
              text: "We couldn't reach the server, please try again. \nIf the problem persists, please contact the system administrator",
            };
            break;
          default:
            error = {
              title: "Error",
              text: `Request unavailable.\nError: ${validation.error}`,
            };
        }
        Utils.Alert(error);
      } else {
        window.location.href = "/";
      }
    }

    setLoading(false);
  };

  return (
    <div className='content loginPage'>
      <Loading visible={loading} />
      <div className='card'>
        <img className='wave-yellow' src='/images/waves.png' alt='' />
        <div className='welcome'>
          <img src='/images/logos/Logo-flag.png' alt='' />
          <p className='text-shadow'>
            Over four decades of history, Friboi has become the largest Beef packer and major Beef exporter in
            Brazil. Recognized as a leading global brand, with presence in over 70 countries we have the
            unique responsibility to take care of our beef which can be translated into quality,
            sustainability, food safety, health, nutrition and well being of millions of families in the
            world. This makes us very proud of doing our best every day to be a trustworthy beef brand. In
            order to feed the world with the best beef there is to offer we count on the most qualified team
            followed by the best facilities in Brazil.
          </p>
          <div className='logos'>
            <div className='logoContainer'>
              <img className='logo-1953' src='/images/logos/1953@2x.png' alt='' />
            </div>
            <div className='logoContainer'>
              <img className='logo-black' src='/images/logos/Black-02.png' alt='' />
            </div>
            <div className='logoContainer'>
              <img className='logo-farms' src='/images/logos/Farms@2x.png' alt='' />
            </div>
            <div className='logoContainer'>
              <img className='logo-grain' src='/images/logos/Grain Valley@2x.png' alt='' />
            </div>
            <div className='logoContainer'>
              <img src='/images/logos/Steakhouse@2x.png' alt='' />
            </div>
          </div>
        </div>
        <div className='login'>
          <div className='logo'>
            <div className='logo-image'>
              <img src='/images/logos/FRIBOI_White.png' alt='' />
            </div>
            <label htmlFor=''>
              Client
              <br />
              Portal
            </label>
          </div>
          <div className='error'>{error}</div>
          <form name='loginForm' className='form' ref={form}>
            <div className='username field'>
              <TextInput value={username} caption='Username' onChange={setUsername} />
            </div>
            <div className='password field'>
              <TextInput value={password} type='password' caption='Password' onChange={setPassword} />
            </div>
            <div className='captcha' onClick={onLoad}>
              <HCaptcha sitekey='aa9a89e8-448c-4630-a02c-579ac59e7c66' onVerify={setToken} ref={captchaRef} />
            </div>
            <div className='loginButton'>
              <Button type='red' caption='Login' onClick={handleLoginButton} />
            </div>
            <div className='captcha'>
              <script
                type='text/javascript'
                src='https://70f2ffa2d6e2.us-east-1.captcha-sdk.awswaf.com/70f2ffa2d6e2/jsapi.js'
                defer
              ></script>
            </div>
            <div className='forgotpassword'>
              <Link to='/forgotpassword'>Forgot Password / First Login?</Link>
            </div>
            {/* <div className='forgotpassword'>
              <Link to='/firstlogin'>First Login?</Link>
            </div> */}
          </form>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <span style={{ fontSize: "10px" }}>v0.1.0</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
